class CreateAccountModal extends HTMLElement {
  constructor() {
    super();

    this.selectElements();
    this.attachListeners();
  }

  selectElements() {
    this.form = this.querySelector("form");
    this.registerBtn = this.querySelector("button#register-user");
  }

  validate() {
    let valid = true;
    if (!/[A-Z]/.test(this.form.elements["customer[password]"].value)) {
      this.showError({
        element: this.form.elements["customer[password]"],
        error: "passwords must contain at least one uppercase letter.",
      });
      valid = false;
    }
    if (!/[a-z]/.test(this.form.elements["customer[password]"].value)) {
      this.showError({
        element: this.form.elements["customer[password]"],
        error: "passwords must contain at least one lowercase letter.",
      });
      valid = false;
    }
    if (!/[0-9]/.test(this.form.elements["customer[password]"].value)) {
      this.showError({
        element: this.form.elements["customer[password]"],
        error: "passwords must contain at least one number.",
      });
      valid = false;
    }
    if (!/[#$^+=!*()@%&?-]/.test(this.form.elements["customer[password]"].value)) {
      this.showError({
        element: this.form.elements["customer[password]"],
        error:
          "passwords must contain at least one symbol. # $ ^ + = ! * ( ) @ % & ? -",
      });
      valid = false;
    }
    if (
      this.form.elements["customer[password]"].value !==
      this.form.elements["customer[password_confirmation]"].value
    ) {
      this.showError({
        element: this.form.elements["customer[password_confirmation]"],
        error: "passwords must be identical",
      });
      valid = false;
    }

    return valid;
  }

  showError({ element, error }) {
    const errorMsg = element
      .closest("div.base-input")
      .querySelector("div#error-msg");
    errorMsg.innerHTML += `
            <span data-testid="errorMessage" class="block cl-error h6">
                ${error}
            </span>
        `;
  }

  clearErrors() {
    this.form
      .querySelectorAll("div#error-msg")
      .forEach((node) => node.replaceChildren());
  }

  async submit(e) {
   
    this.clearErrors();

    // if (!this.form.reportValidity()) return;

    // if (!this.validate()) {
    //   e.preventDefault();
    //   return window.notificationsManager.open({
    //     type: window.notificationsManager.types.NOTIFICATION_ERROR,
    //     body: "Please fix the validation errors",
    //   });
    // }

    // this.form.submit();
  }

  attachListeners() {
    this.registerBtn.addEventListener("click", this.submit.bind(this));

    this.querySelectorAll("input.empty").forEach((el) =>
      el.addEventListener("change", (e) => {
        if (e.target.value) e.target.classList.remove("empty");
        else e.target.classList.add("empty");
      })
    );

    this.querySelectorAll("button[title='Toggle password visibility']").forEach(
      (el) =>
        el.addEventListener("click", (e) => {
          const input = el.parentNode.querySelector("input");
          if (input.type === "password") {
            input.type = "text";
            el.querySelector(".js-icon-visibility-off").classList.add("hidden")
            el.querySelector(".js-icon-visibility-on").classList.remove("hidden")
          } else if (input.type === "text") {
            input.type = "password";
            el.querySelector(".js-icon-visibility-off").classList.remove("hidden")
            el.querySelector(".js-icon-visibility-on").classList.add("hidden")
          }
        })
    );
  }
}

customElements.define("create-account-modal", CreateAccountModal);
